'use strict';

import {getUrlParameter, getVueTemplate} from '../../../_imports/utils/utils.common.js';
import BaseVueComponent from "../../../_imports/shared/base-vue-component.vue.common.js";

export default {
    template: getVueTemplate('video-chapters'),
    mixins: [
        BaseVueComponent,
    ],
    data() {
        return {
            chapters: null,
            activeChapter: null,
            videoPlayer: {
                innerPlayer: null,
            }
        }
    },
    computed: {
        hasChapters() {
            return this.chapters.length > 0;
        },
        chaptersList() {
            if(this.chapters) {
                for(const chapter of this.chapters) {
                    chapter.marker = Math.trunc(chapter.time);
                    chapter.readableTime = this.readableTime(chapter.time);
                }

                return this.chapters;
            }
        }
    },
    methods: {
        readableTime(time) {
            // Ex: 0:02, 0:21, 1:22

            time = Math.round(time);
            const minutes = Math.floor(time / 60);
            const seconds = (time % 60).toFixed(0);

            return `${minutes}:${(seconds < 10 ? '0' : '')}${seconds}`;
        },
        goToChapter(chapter, index) {
            const player = this?.videoPlayer?.innerPlayer;

            if(player) {
                player.time(chapter.time);
            }

            this.setActiveChapterInChapterTab(index);
            this.setChapterUrlParameter(index);
            this.scrollToVideo();
        },
        scrollToVideo() {
            const isInModal = this.$el.closest('[am-modal-container]') !== null;
            
            if (isInModal) {
                Velocity(document.querySelector('[am-modal].open .modal-body'), 'scroll',{
                    container: document.querySelector('[am-modal].open .modal-container'),
                    duration: 1200,
                    easing: [1000, 80]
                });
            } else {
                Velocity(document.body, 'scroll', {
                    duration: 1200,
                    easing: [1000, 80]
                });
            }
        },
        setChapterUrlParameter(index) {
            const url = new URL(window.location.href);
            
            if (index !== null) {
                url.searchParams.set('chapter', index);
            } else {
                url.searchParams.delete('chapter');
            }
            
            const newUrl = url.hash 
                ? `${url.pathname}${url.search}${url.hash}`
                : `${url.pathname}${url.search}`;

            window.history.pushState(null, null, newUrl);
        },
        setActiveChapterOnVideoTimeline() {
            const videoProgress = JSON.parse(localStorage.getItem(`wistia-video-progress-${this.componentData.videoCode}`));
            const lastTime = videoProgress?.lastTime;

            if(lastTime) {
                this.videoPlayer.innerPlayer.time(lastTime);
            }
        },
        setActiveChapterInChapterTab(index) {
            this.activeChapter = index;
        },
        setActiveChapterOnLoad() {
            const getChapterInUrl = getUrlParameter('chapter');

            if(getChapterInUrl) {
                this.setActiveChapterInChapterTab(parseInt(getChapterInUrl))
                this.setActiveChapterOnVideoTimeline();
            }
        },
        setCurrentChapterWhenVideoPlay(player) {
            if(this.chaptersList) {
                Wistia.api(this.componentData.videoCode).bind('secondchange', (time) => {
                    for(const [index, chapter] of this.chaptersList.entries()) {
                        if(time === Math.trunc(chapter.time)) {
                            this.activeChapter = index;
                        }
                    }

                    this.setChapterUrlParameter(this.activeChapter);
                });
            }
        },
        reorderChapterList() {
            if(this.chapters) {
                if (this.chapters.every(obj => 'time' in obj)) {
                    this.chapters = this.chapters.sort((chapterA, chapterB) => chapterA.time - chapterB.time);
                } else {
                    console.error("The 'time' key is missing for some objects");
                }
            }
        },
        initChapters() {
            this.chapters = this.videoPlayer.innerPlayer?.plugin?.chapters?.chaptersManager?.options?.chapterList;

            this.reorderChapterList();
            this.setCurrentChapterWhenVideoPlay();
            this.setActiveChapterOnLoad();
        }
    },
    created() {
        window._wq = window._wq || [];
        window._wq.push({
            id: this.componentData.videoCode,
            onReady: (player) => {
                this.videoPlayer.innerPlayer = player;
                this.initChapters();
            }
        });
    },
    destroyed() {
        this.videoPlayer = {
            innerPlayer: null,
        };
    }
};